<footer id="footer">
  <main class="slogan mb-4 d-flex align-items-middle mt-md-5 mb-md-5">
    <section class="align-items-middle w-100">


      <div class="container d-block align-items-middle">
        <div class="row w-100 slogan-row">
          <div class="col-md-12 col-lg-6 d-flex align-items-center justify-content-md-start pl-lg-4 my-md-0 my-0 footer-image">
            <img src="../../../assets/images/logos/takeabreath_logo_footer.png" width="228px" height="44px">
          </div>
          <div class="col-lg-6 d-flex align-items-center justify-content-lg-end text-center text-md-right pr-md-0 my-md-0 my-0">
            <p class="mb-0 footer-text">Responding to a community in need</p>
          </div>
        </div>

        <div class="d-block mt-3 mt-md-1">
          <div class="col-12 text-center text-lg-right">
            <a target="_blank" href="https://apps.apple.com/nz/app/id1534039062" class="d-block d-md-inline"><img class="pt-1" src="../../../../assets/images/logos/apple-badge.png" id="apple-badge" width="130"></a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=world.takeabreath.reminder"><img class="pt-1" src="../../../../assets/images/logos/google-play-badge.png" id="google-badge" width="130"></a>
          </div>
        </div>
      </div>

    </section>
  </main>

  <div class="container py-md-4 mb-md-4">
    <div class="copyright col-md-12 col-lg-8 text-center text-md-left">
      <ul class="list-unstyled text-left">
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/how-it-works/" target="_blank">How it Works</a></li>
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/seminars/" target="_blank">Seminars</a></li>
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/community/" target="_blank">Community</a></li>
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/take-a-breath-week/" target="_blank">Take a Breath Week</a></li>
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/contact/" target="_blank">Contact</a></li>
        <li class="float-md-left pr-md-4"><a href="https://www.takeabreath.world/privacy-policy/" target="_blank">Privacy Policy</a></li>
      </ul>
    </div>
    <div class="reserves col-lg-4 d-flex justify-content-lg-end pt-3 pt-md-0">
      All right reserved &copy; <span>Take a Breath 2020</span>
    </div>
  </div>
</footer>

<a class="back-to-top" (click)="scrollToTop()"><i class="fa fa-chevron-up"></i></a>
